import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { axiosBeelineRequest } from '@beef/utils';
import { Content } from "../../../../getContent/Content";
import { ECommonStatus, EPaymentStatus, PAYMENT_URL, STATUS_URL } from "../../../constants";
import { checkIsClientSide } from "../../../../../utils/utils";
import { contains, findFirst } from "../../../../../../utils/arrays";
import { poll } from "../../../../../../utils/fn";
import { recursiveMerge } from "../../../../../../utils/recursiveMerge";
import { redirect } from "../../../../../../utils/redirect";
import { getValuesOfEnum } from "../../../../../../utils/types";
var composePaymentUrl = function composePaymentUrl(userType, ctn, sum) {
  return "/customers/how-to-pay/popolnenie-scheta/#/ImmediatePayment/".concat(userType, "/?ctn=").concat(ctn, "&sum=").concat(sum);
};

/**
 * @desc: редирект на страницу оплаты
 * @param param { ctn: string, sum: string, type: string } ctn, передавать без маски
 */
export var redirectToPayment = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var ctn, sum, type, isAuth, userType, sumAmount, _sum, url;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          ctn = _ref.ctn, sum = _ref.sum, type = _ref.type, isAuth = _ref.isAuth;
          if (checkIsClientSide()) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", undefined);
        case 3:
          userType = type === 'internet' ? 'Fttb' : 'Mobile';
          sumAmount = Number(sum);
          _sum = !Number.isNaN(sumAmount) ? sumAmount.toFixed(0) : '';
          url = findFirst([isAuth && composePaymentUrl(userType, ctn, _sum), '/login']);
          if (url) {
            _context.next = 9;
            break;
          }
          throw new Error('no redirect url provided');
        case 9:
          return _context.abrupt("return", redirect(url));
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function redirectToPayment(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var sendStatusRequest = function sendStatusRequest(paymentId) {
  return axiosBeelineRequest({
    url: STATUS_URL,
    params: {
      paymentId: paymentId
    }
  });
};
export var sendCardPayment = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
    var _settings$card;
    var _yield$axiosBeelineRe, _yield$axiosBeelineRe2, paymentId, status, responseStatus, hasErrors, isSuccessfulWithoutId, _Content$getInstance$, settings, _recursiveMerge, interval, timeout, _yield$poll, isSuccessful;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return axiosBeelineRequest({
            originalResponse: true,
            url: PAYMENT_URL,
            method: 'POST',
            data: data
          });
        case 2:
          _yield$axiosBeelineRe = _context2.sent;
          _yield$axiosBeelineRe2 = _yield$axiosBeelineRe.data;
          paymentId = _yield$axiosBeelineRe2.paymentId;
          status = _yield$axiosBeelineRe2.status;
          responseStatus = _yield$axiosBeelineRe.status;
          if (!(responseStatus !== 200 && !status)) {
            _context2.next = 9;
            break;
          }
          throw new Error('unsuccessful response');
        case 9:
          if (status) {
            _context2.next = 11;
            break;
          }
          return _context2.abrupt("return", ECommonStatus.Error);
        case 11:
          hasErrors = contains([].concat(_toConsumableArray(getValuesOfEnum(EPaymentStatus)), [ECommonStatus.Error]), status);
          isSuccessfulWithoutId = !paymentId && status === ECommonStatus.Process;
          if (!(hasErrors || isSuccessfulWithoutId)) {
            _context2.next = 15;
            break;
          }
          return _context2.abrupt("return", status);
        case 15:
          if (paymentId) {
            _context2.next = 18;
            break;
          }
          console.warn('No payment id provided');
          return _context2.abrupt("return", ECommonStatus.Error);
        case 18:
          _Content$getInstance$ = Content.getInstance().getData(), settings = _Content$getInstance$.requestSettings;
          _recursiveMerge = recursiveMerge(settings.default, (_settings$card = settings.card) !== null && _settings$card !== void 0 ? _settings$card : {}), interval = _recursiveMerge.interval, timeout = _recursiveMerge.timeout;
          _context2.next = 22;
          return poll(function () {
            return sendStatusRequest(paymentId);
          }, function (_ref4) {
            var _isSuccessful = _ref4.isSuccessful,
              _status = _ref4.status;
            return !_isSuccessful && _status !== ECommonStatus.Error;
          }, interval, timeout);
        case 22:
          _yield$poll = _context2.sent;
          isSuccessful = _yield$poll.isSuccessful;
          if (!isSuccessful) {
            _context2.next = 26;
            break;
          }
          return _context2.abrupt("return", ECommonStatus.Success);
        case 26:
          return _context2.abrupt("return", ECommonStatus.Error);
        case 27:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function sendCardPayment(_x2) {
    return _ref3.apply(this, arguments);
  };
}();